module.exports = __webpack_public_path__ + "img/prize-type-5.e4f8acde.png";